// Nguồn : https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist

import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import restaurantReducer from './restaurantSlice'
import cartReducer from './cartSlice'
import modalDropdownReducer from './modalDropDownSlice'
import popupTopPageReducer from './popupTopPageSlice'
import searchFoodReducer from '~/views/SearchDishes/searchSlice'
import callStaffReducer from '~/views/CallStaff/callStaffSlice'
import paymentReducer from '~/views/Payment/slices/paymentSlice'
import menuReducer from '~/views/Menu/slices/menuSlice'
import itemDetailReducer from '~/views/Menu/slices/itemDetailSlice'
import orderHistoryReducer from '~/views/OrderHistory/slices'

const rootReducer = combineReducers({
  restaurant: restaurantReducer,
  menu: menuReducer,
  itemDetail: itemDetailReducer,
  cart: cartReducer,
  modalDropdown: modalDropdownReducer,
  popupTopPage: popupTopPageReducer,
  searchFood: searchFoodReducer,
  callStaff: callStaffReducer,
  payment: paymentReducer,
  orderHistory: orderHistoryReducer,
})

const persistConfig = {
  key: 'v1.0.2', // Chú ý khi thay đổi bất kỳ thông tin nào trong persist phải tăng version lên tránh cache cũ
  version: 1,
  storage,
  whitelist: ['cart', 'restaurant'], // danh sách những slice cần persist
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)
